import { useQuery } from "react-query";
import { IPaginatedResponse } from "../../../../interfaces/response";
import { getData } from "../../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";

const USE_MOCK = false;

export interface IPendingWalletCreationParams {
  startDate?: string;
  endDate?: string;
  searchValue?: string;
}

export interface IPendingWalletCreationRequest {
  makerCheckerReference: string;
  targetId: number;
  consumerType: string;
  currency: string;
  channelId: string | null;
  providerType: string;
  effectiveDate: string;
  clientType: string;
  isExternalWallet: boolean;
  isDigitalBank: boolean;
  createdByAdmin: boolean;
  postNoDebit: boolean;
  note: string;
}

export const getPendingWalletCreationRequests = async ({
  startDate,
  endDate,
  searchValue,
}: IPendingWalletCreationParams): Promise<
  IPaginatedResponse<IPendingWalletCreationRequest[]>
> => {
  if (USE_MOCK) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const allData = [
          {
            makerCheckerReference: "1e5321f6-939b-4281-8b58-1cbfe3680860",
            targetId: 1600,
            consumerType: "Customer",
            currency: "NGN",
            channelId: null,
            providerType: "AdvanclyMFB",
            effectiveDate: "2026-01-05T00:00:00",
            clientType: "Organisation",
            isExternalWallet: false,
            isDigitalBank: true,
            createdByAdmin: false,
            postNoDebit: true,
            note: "Wallet created by admin",
          },
          {
            makerCheckerReference: "2f6432g7-040c-5392-9c69-2dcgf4791971",
            targetId: 1601,
            consumerType: "Customer",
            currency: "USD",
            channelId: null,
            providerType: "AdvanclyMFB",
            effectiveDate: "2026-01-06T00:00:00",
            clientType: "Individual",
            isExternalWallet: false,
            isDigitalBank: true,
            createdByAdmin: true,
            postNoDebit: false,
            note: "External wallet request",
          },
          {
            makerCheckerReference: "3g7543h8-151d-6403-0d70-3edgh5802082",
            targetId: 1602,
            consumerType: "Customer",
            currency: "NGN",
            channelId: null,
            providerType: "AdvanclyMFB",
            effectiveDate: "2026-01-07T00:00:00",
            clientType: "Organisation",
            isExternalWallet: true,
            isDigitalBank: false,
            createdByAdmin: false,
            postNoDebit: true,
            note: "Digital bank wallet creation",
          },
          {
            makerCheckerReference: "4h8654i9-262e-7514-1e81-4fehi6913193",
            targetId: 1603,
            consumerType: "Customer",
            currency: "GBP",
            channelId: null,
            providerType: "AdvanclyMFB",
            effectiveDate: "2026-01-08T00:00:00",
            clientType: "Individual",
            isExternalWallet: false,
            isDigitalBank: true,
            createdByAdmin: true,
            postNoDebit: true,
            note: "Standard wallet creation",
          },
          {
            makerCheckerReference: "5i9765j0-373f-8625-2f92-5gfij7024204",
            targetId: 1604,
            consumerType: "Merchant",
            currency: "NGN",
            channelId: null,
            providerType: "AdvanclyMFB",
            effectiveDate: "2026-01-09T00:00:00",
            clientType: "Organisation",
            isExternalWallet: false,
            isDigitalBank: true,
            createdByAdmin: false,
            postNoDebit: false,
            note: "Merchant wallet request",
          },
        ];

        resolve({
          message: "Data Fetched Successfully",
          status: true,
          status_code: 200,
          page: 1,
          pageSize: allData.length,
          totalCount: allData.length,
          totalPages: 1,
          data: allData,
        });
      }, 1000);
    });
  }

  let queryParams = "?";
  if (startDate) queryParams += `startDate=${startDate}&`;
  if (endDate) queryParams += `endDate=${endDate}&`;
  if (searchValue) queryParams += `searchValue=${searchValue}&`;

  const { data } = await getData(
    `${ajaxEndpoints.GET_PENDING_WALLET_CREATION_REQUESTS}${queryParams}`
  );

  return data;
};

export const usePendingWalletCreationRequests = (
  params: IPendingWalletCreationParams
) => {
  return useQuery<IPaginatedResponse<IPendingWalletCreationRequest[]>, Error>(
    ["getPendingWalletCreationRequests", params],
    () => getPendingWalletCreationRequests(params),
    {
      refetchOnWindowFocus: false,
    }
  );
};
